import React, { useEffect, useState } from 'react';
import { useGlobalContext } from '../../context/Context';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

// COMPONENTS
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';

// ASSETS
import spinner from '../../assets/purple-btn-spinner.svg';
import { toast } from 'react-toastify';
import { FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const NewMatchOfTheDay = () => {
  const { showProfileModal, baseURL } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [competitions, setCompetitions] = useState([]);
  const [homeImage, sethomeImage] = useState(``);
  const [awayImage, setAwayImage] = useState(``);

  const { token } = JSON.parse(sessionStorage.getItem(`adminData`));
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      homeTeam: ``,
      awayTeam: ``,
      matchTime: ``,
      competitionLogo: ``,
      competition: ``,
      instagramLink: ``,
      twitterLink: ``,
    },
    validationSchema: Yup.object({
      homeTeam: Yup.string().required(`Please provide home team`),
      awayTeam: Yup.string().required(`Please provide away team`),
      matchTime: Yup.string().required(`Please provide match time`),
      competitionLogo: Yup.string().required(`Please provide competition logo`),
      competition: Yup.string().required(`Please provide competition name`),
      instagramLink: Yup.string().required(
        `Please provide instagram prediction link`
      ),
      twitterLink: Yup.string().required(
        `Please provide twitter prediction link`
      ),
    }),
    onSubmit() {
      createMatch();
    },
  });

  const createMatch = async () => {
    const {
      awayTeam,
      competition,
      competitionLogo,
      homeTeam,
      instagramLink,
      matchTime,
      twitterLink,
    } = formik.values;
    const formData = new FormData();

    formData.append(`homeTeamLogo`, homeImage);
    formData.append(`awayTeamLogo`, awayImage);
    formData.append(`awayTeam`, awayTeam);
    formData.append(`competition`, competition);
    formData.append(`competitionLogo`, competitionLogo);
    formData.append(`homeTeam`, homeTeam);
    formData.append(`instagramLink`, instagramLink);
    formData.append(`matchTime`, matchTime);
    formData.append(`twitterLink`, twitterLink);

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${baseURL}/match-of-the-day`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      toast.success(data.msg);
      navigate(`/match-of-the-day`);
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.msg);
    }
  };

  const fetchCompetitons = async () => {
    try {
      const { data } = await axios.get(`${baseURL}/competitions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCompetitions(data.competitions);
    } catch (error) {}
  };

  useEffect(() => {
    fetchCompetitons();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='new-motd-page'>
      <Navbar
        category={`Menu > Match of the day >`}
        categoryLink={`/match-of-the-day`}
        currentPage={`New Match`}
      />
      <Sidebar activePage={4} />
      <div className={`main-content ${showProfileModal ? `back` : null}`}>
        <div className='title-btn'>
          <FaChevronLeft onClick={() => navigate(`/match-of-the-day`)} />
          <h2 className='title'>New Match</h2>
        </div>

        {/* TICKET DETAILS BOX */}
        <div className='ticket-details'>
          <h3 className='title'>Match Details</h3>

          <form action='' onSubmit={formik.handleSubmit}>
            {/* HOME TEAM */}
            <div className='form-control'>
              <label
                htmlFor='homeTeam'
                className={
                  formik.errors.homeTeam && formik.touched.homeTeam
                    ? `error`
                    : ``
                }
              >
                {formik.errors.homeTeam && formik.touched.homeTeam
                  ? formik.errors.homeTeam
                  : `Home Team`}{' '}
                <span>*</span>
              </label>
              <input
                type='text'
                id='homeTeam'
                value={formik.values.homeTeam}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='homeTeam'
              />
            </div>

            {/* HOME TEAM LOGO */}
            <div className='form-control'>
              <label htmlFor='image'>Home Team Logo</label>
              <input
                type='file'
                accept='image/*'
                id='image'
                name='image'
                onChange={(e) => sethomeImage(e.target.files[0])}
                required
              />
            </div>

            {/* AWAY TEAM */}
            <div className='form-control'>
              <label
                htmlFor='awayTeam'
                className={
                  formik.errors.awayTeam && formik.touched.awayTeam
                    ? `error`
                    : ``
                }
              >
                {formik.errors.awayTeam && formik.touched.awayTeam
                  ? formik.errors.awayTeam
                  : `Away Team`}{' '}
                <span>*</span>
              </label>
              <input
                type='text'
                id='awayTeam'
                value={formik.values.awayTeam}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='awayTeam'
              />
            </div>

            {/* AWAY TEAM LOGO */}
            <div className='form-control'>
              <label htmlFor='image'>Away Team Logo</label>
              <input
                type='file'
                accept='image/*'
                id='image'
                name='image'
                onChange={(e) => setAwayImage(e.target.files[0])}
                required
              />
            </div>

            {/* COMPETITION */}
            <div className='form-control'>
              <label
                htmlFor='competition'
                className={
                  formik.errors.competition && formik.touched.competition
                    ? `error`
                    : ``
                }
              >
                {formik.errors.competition && formik.touched.competition
                  ? formik.errors.competition
                  : `Competition Name`}{' '}
                <span>*</span>
              </label>
              <input
                type='text'
                id='competition'
                value={formik.values.competition}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='competition'
              />
            </div>

            {/* COMPETITION LOGO */}
            <div className='form-control'>
              <label
                htmlFor='competitionLogo'
                className={
                  formik.errors.competitionLogo &&
                  formik.touched.competitionLogo
                    ? `error`
                    : ``
                }
              >
                {formik.errors.competitionLogo && formik.touched.competitionLogo
                  ? formik.errors.competitionLogo
                  : `Competition Logo`}{' '}
                <span>*</span>
              </label>
              <select
                name='competitionLogo'
                id='competitionLogo'
                value={formik.values.competitionLogo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option defaultChecked hidden>
                  Select Logo
                </option>
                {competitions.map((logo) => {
                  const { _id, competitionName, competitionLogo } = logo;
                  return (
                    <option
                      value={`https://api.crspredictions.com${competitionLogo}`}
                      key={_id}
                    >
                      {competitionName} Logo
                    </option>
                  );
                })}
              </select>
            </div>

            {/* MATCH TIME */}
            <div className='form-control'>
              <label
                htmlFor='matchTime'
                className={
                  formik.errors.matchTime && formik.touched.matchTime
                    ? `error`
                    : ``
                }
              >
                {formik.errors.matchTime && formik.touched.matchTime
                  ? formik.errors.matchTime
                  : `Match Time`}{' '}
                <span>*</span>
              </label>
              <input
                name='matchTime'
                id='matchTime'
                type='datetime-local'
                value={formik.values.matchTime}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>

            {/* INSTAGRAM LINK */}
            <div className='form-control'>
              <label
                htmlFor='instagramLink'
                className={
                  formik.errors.instagramLink && formik.touched.instagramLink
                    ? `error`
                    : ``
                }
              >
                {formik.errors.instagramLink && formik.touched.instagramLink
                  ? formik.errors.instagramLink
                  : `Instagram Link`}{' '}
                <span>*</span>
              </label>
              <input
                type='text'
                id='instagramLink'
                value={formik.values.instagramLink}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='instagramLink'
              />
            </div>

            {/* TWITTER LINK */}
            <div className='form-control'>
              <label
                htmlFor='twitterLink'
                className={
                  formik.errors.twitterLink && formik.touched.twitterLink
                    ? `error`
                    : ``
                }
              >
                {formik.errors.twitterLink && formik.touched.twitterLink
                  ? formik.errors.twitterLink
                  : `Twitter Link`}{' '}
                <span>*</span>
              </label>
              <input
                type='text'
                id='twitterLink'
                value={formik.values.twitterLink}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name='twitterLink'
              />
            </div>

            {/* SUBMIT BUTTON */}
            <button type='submit' className='primary'>
              Create {loading ? <img src={spinner} alt='' /> : null}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default NewMatchOfTheDay;
